import { onTTFB } from 'web-vitals/attribution';
import type { TTFBMetricWithAttribution } from 'web-vitals/attribution';
import type { MetricReport } from '../contracts/metricReport';
import { toTtfbReport } from './mappers';

const onTimeToFirstByte = (report: (m: MetricReport) => void): void => {
  onTTFB((metric: TTFBMetricWithAttribution) => {
    report(toTtfbReport(metric));
  });
};

export default onTimeToFirstByte;
